const AdminBackIcon = () => {
  return(
      <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" fill="none"><circle cx="22.5" cy="22.5" r="22.5" fill="#6FE1B8"/><path fill="#546EDB" fillRule="evenodd" d="M26.535 16.174c.62.565.62 1.48 0 2.045l-4.7 4.281 4.7 4.281c.62.565.62 1.48 0 2.046a1.7 1.7 0 0 1-2.247 0l-5.823-5.304a1.357 1.357 0 0 1 0-2.046l5.823-5.303a1.7 1.7 0 0 1 2.247 0Z" clipRule="evenodd"/></svg>
  )
}

export default AdminBackIcon;